import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import { Dialog, Grid, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ShareIcon from '@material-ui/icons/Share';
import CustomButton from '../common/customButton';
import imgParams from '../../utils/imageUtil';
import { useTablet } from '../../hooks/utilHooks';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { RWebShare } from 'react-web-share';

const ImagesModal = ({
  images,
  openModal,
  handleClose,
  selectedImagePosition,
  postShareInfo,
  isSellerCarousel,
}) => {
  function handleStepChange(step) {
    setActiveStep(step);
  }
  const isTablet = useTablet();
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(selectedImagePosition);
  useEffect(() => {
    setActiveStep(selectedImagePosition);
  }, [selectedImagePosition]);
  const maxSteps = images && images.length;

  const handleClickArrow = (e, isNext) => {
    e.stopPropagation();
    const currentIndex = activeStep === 0 ? maxSteps - 1 : activeStep - 1;
    setActiveStep(currentIndex);
    if (isNext) {
      const currentIndex = activeStep === maxSteps - 1 ? 0 : activeStep + 1;
      setActiveStep(currentIndex);
    }
  };

  return (
    <Dialog
      disableBackdropClick={false}
      className={classes.mainDialog}
      fullScreen
      open={openModal}
      onClose={handleClose}
    >
      <Grid
        className={`stickToTop ${classes.addBg}`}
        spacing={3}
        justify="space-between"
        container
      >
        <Box px={6} py={2}>
          <CustomButton
            onClick={handleClose}
            variant="iconButton"
            icon={
              <CloseIcon
                style={{ color: 'white' }}
                width="18px"
                height="16px"
              />
            }
          />
        </Box>
        <Box px={6} py={2}>
          {postShareInfo && postShareInfo.url && (
            <RWebShare
              data={{
                text: postShareInfo?.text,
                url: postShareInfo?.url,
                title: postShareInfo?.title,
              }}
              onClick={() => console.log('shared successfully!')}
            >
              <ShareIcon
                style={{ color: 'white', cursor: 'pointer' }}
                width="18px"
                height="16px"
              />
            </RWebShare>
          )}
        </Box>
      </Grid>

      <Box className={classes.carouselMain}>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images &&
            images.map((image, index) => (
              <div className={classes.imgContainer} key={image.id}>
                {Math.abs(activeStep - index) <= 2 ? (
                  <img
                    className={classes.img}
                    src={imgParams(
                      isSellerCarousel
                        ? image.type === 'V'
                          ? image.thumbnail
                          : image.url
                        : image.src,
                      1600
                    )}
                    alt="sheroes user post"
                    width={isTablet ? '100%' : '40%'}
                  />
                ) : null}
              </div>
            ))}
        </SwipeableViews>
        {!isTablet && (
          <Box position="absolute" width={1} px={4}>
            {activeStep !== 0 && (
              <KeyboardArrowLeftIcon
                className={classes.arrow}
                onClick={(e) => handleClickArrow(e)}
              />
            )}
            {activeStep !== maxSteps - 1 && (
              <KeyboardArrowRightIcon
                className={`${classes.arrow} ${classes.arrowRight}`}
                onClick={(e) => handleClickArrow(e, true)}
              />
            )}
          </Box>
        )}
      </Box>
      <Box py={2} className={`stickToBottom ${classes.stepText}`}>
        {activeStep + 1 + '/' + maxSteps}
      </Box>
    </Dialog>
  );
};
const useStyles = makeStyles((theme) => ({
  img: {
    height: 'auto',
    display: 'block',
    margin: '0px auto',
  },
  imgContainer: {
    height: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  mainDialog: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'black',
  },
  stepText: {
    color: 'white',
    right: 0,
    textAlign: 'center',
    backgroundColor: 'rgba(0,0,0,0.7)',
    width: '50px',
    margin: '0px auto',
    bottom: theme.spacing(4),
  },
  carouselMain: {
    display: 'flex',
    alignItems: 'center',
    overflowY: 'auto',
  },
  addBg: {
    marginTop: '0px',
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  arrow: {
    background: 'white',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    color: '#3c3c3c',
  },
  arrowRight: {
    float: 'right',
  },
}));

export default ImagesModal;
